import { render, staticRenderFns } from "./DeliveryCampaignGroupMemberPendingsPage.vue?vue&type=template&id=fb4ecb04&scoped=true"
import script from "./DeliveryCampaignGroupMemberPendingsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupMemberPendingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4ecb04",
  null
  
)

export default component.exports